<template>
  <el-dialog v-if="isVisible" title="Order is locked" :visible.sync="isVisible" width="30%">
    <p>{{ lock.error }}</p>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "locked-dialog",
  props: {
    lockKey: String,
  },
  data() {
    return {
      isVisible: false
    }
  },
  watch: {
    lock(newLock) {
      this.isVisible = newLock.error && newLock.error.length > 0;
    }
  },
  computed: {
    ...mapGetters({
      getLock: 'getLock',
    }),
    lock() {
      const lock = this.getLock(this.lockKey);
      if (!lock) {
        return {
          error: '',
        };
      }
      return lock;
    },
  }
};
</script>
